import { ROLES } from "../constants/constants";

export function NavigateToUrl(statusCode: number, route?: any) {
    switch (statusCode) {
        case 403:
            return ('/403')
        case 404:
            return ('/404')
        default:
            return (route);
    }
}

export function routePrefix(user: any) {
    if (user?.role?.name === ROLES.INDIVIDUAL_USER) {
        return null;
    } else if (user?.role?.name === ROLES.SITE_ADMIN || user?.role?.name === ROLES.SUPER_ADMIN) {
        return "admin"
    } else {
        return user?.organization?.orgCode
    }
}

function isObject(obj: any) {
    return obj !== null && typeof obj === 'object';
}

export function deepEqual(obj1: any, obj2: any) {
    // Check if both are the same reference
    if (obj1 == obj2) return true;

    // Check if either is not an object
    if (!isObject(obj1) || !isObject(obj2)) return false;

    // Get keys of both objects
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // Check if they have the same number of keys
    if (keys1.length !== keys2.length) return false;

    // Check each key in obj1
    for (let key of keys1) {
        // Check if key exists in obj2 and recursively compare values
        if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
            return false;
        }
    }

    return true;
}